"use strict";

(function (Drupal) {
  Drupal.behaviors.mixed_gallery = {
    attach: function attach(context, settings) {
      var galleries = context.querySelectorAll('.mixed-gallery');
      if (!galleries.length) {
        return;
      }
      galleries.forEach(function (gallery) {
        var caption = gallery.querySelector('.mixed-gallery__caption');
        var wrap = gallery.querySelector('.mixed-gallery--wrap');
        var slides = gallery.querySelectorAll('a');
        var next = gallery.querySelector('[data-direction="right"]');
        var prev = gallery.querySelector('[data-direction="left"]');

        // dragging helpers
        var galleryIsDragging = function galleryIsDragging() {
          wrap.classList.add('is-dragging');
        };
        var galleryIsStopped = function galleryIsStopped() {
          wrap.classList.remove('is-dragging');
        };

        // gallery caption
        var galleryCaption = function galleryCaption() {
          var index = slider.getInfo().index + 1;
          var active = gallery.querySelector("a:nth-child(".concat(index, ")"));
          var activeCaption;
          var activeX;
          var galleryX = gallery.getBoundingClientRect().x;
          setTimeout(function () {
            caption.style.opacity = 1;
            caption.style.transition = 'opacity 0.5s';
          }, 800);
          setTimeout(function () {
            if (!active.querySelector('img')) {
              return;
            }
            activeX = active.querySelector('img').getBoundingClientRect().x - galleryX;
          }, 700);
          activeCaption = active.querySelector('.field--name-media-image-caption .field__item');
          if (activeCaption) {
            caption.innerHTML = activeCaption.innerHTML;
            setTimeout(function () {
              caption.style.paddingLeft = "".concat(activeX, "px");
            }, 700);
          } else {
            caption.innerHTML = '';
          }
        };

        // init
        var slider = tns({
          container: wrap,
          items: 1,
          autoWidth: true,
          autoHeight: true,
          gutter: 10,
          speed: 600,
          center: true,
          arrowKeys: true,
          autoplay: false,
          mouseDrag: true,
          controls: false,
          nav: false,
          loop: true,
          responsive: {
            600: {
              gutter: 10,
              items: 1,
              center: true,
              edgePadding: 150
            },
            1200: {
              gutter: 18,
              items: 1,
              center: true,
              edgePadding: 200
            }
          },
          onInit: galleryCaption
        });

        // events
        slider.events.on('dragMove', galleryIsDragging);
        slider.events.on('dragEnd', galleryIsStopped);
        slider.events.on('transitionStart', function () {
          caption.style.opacity = 0;
          caption.style.removeProperty('transition');
        });
        slider.events.on('transitionEnd', function () {
          setTimeout(function () {
            caption.style.opacity = 1;
            caption.style.transition = 'opacity 0.5s';
          }, 600);
        });
        slider.events.on('indexChanged', galleryCaption);

        // controls
        next.onclick = function () {
          slider.goTo('next');
        };
        prev.onclick = function () {
          slider.goTo('prev');
        };
      });
    }
  };
})(Drupal);